import type { NonModalDialogPrimitiveStateReturn } from '@twilio-paste/core/non-modal-dialog-primitive';

import { createNullableContext, useNullableContext } from '../../../utils/Context';

export interface PopoverStateReturn extends NonModalDialogPrimitiveStateReturn {}

export const DrawerContext = createNullableContext<PopoverStateReturn>('DrawerContext');

export const useDrawerContext = () => useNullableContext(DrawerContext);
